export const setAddress = (data) => {
  localStorage.setItem("data_address", JSON.stringify(data));
};
export const getAddress = () => {
  let data_address = null;

  if (localStorage.getItem("data_address") !== "undefined") {
    data_address = JSON.parse(localStorage.getItem("data_address"));
  }
  return data_address;
};

export const setInforU = (data) => {
  localStorage.setItem("data_info", JSON.stringify(data));
};

export const getInforU = () => {
  let data_info = null;

  if (localStorage.getItem("data_info") !== "undefined") {
    data_info = JSON.parse(localStorage.getItem("data_info"));
  }
  return data_info;
};

export const setInforURespo = (data) => {
  localStorage.setItem("data_info_respo", JSON.stringify(data));
};
export const getInforURespo = () => {
  let data_info_respo = null;

  if (localStorage.getItem("data_info_respo") !== "undefined") {
    data_info_respo = JSON.parse(localStorage.getItem("data_info_respo"));
  }
  return data_info_respo;
};

export const setSecret = (data) => {
  localStorage.setItem("secret", JSON.stringify(data));
};
export const getSecret = () => {
  let sec = null;
  if (localStorage.getItem("secret") !== "undefined") {
    sec = JSON.parse(localStorage.getItem("secret"));
  }
  return sec;
};

export const setPro = (data) => {
  localStorage.setItem("pro", JSON.stringify(data));
};

export const getPro = () => {
  let pro = null;
  if (localStorage.getItem("pro") !== "undefined") {
    pro = JSON.parse(localStorage.getItem("pro"));
  }
  return pro;
};
export const setHelpCase = (data) => {
  localStorage.setItem("helpcase", JSON.stringify(data));
};

export const getHelpCase = () => {
  let helpcase = null;
  if (localStorage.getItem("helpcase") !== "undefined") {
    helpcase = JSON.parse(localStorage.getItem("helpcase"));
  }
  return helpcase;
};

export const clearLocal = () => {
  if (localStorage.getItem("data_address") !== "undefined") {
    localStorage.removeItem("data_address");
  }
  if (localStorage.getItem("fail") !== "undefined") {
    localStorage.removeItem("fail");
  }
  if (localStorage.getItem("helpcase") !== "undefined") {
    localStorage.removeItem("helpcase");
  }
  if (localStorage.getItem("data_info") !== "undefined") {
    localStorage.removeItem("data_info");
  }
  if (localStorage.getItem("data_info_respo") !== "undefined") {
    localStorage.removeItem("data_info_respo");
  }
  if (localStorage.getItem("secret") !== "undefined") {
    localStorage.removeItem("secret");
  }
};
